import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { unsubscribeFromNotifications } from '../firebase-config';

const AuthUser = () => {

    const navigate = useNavigate();

    const getModule = () => {
        const String = localStorage.getItem('modulo');
        const module = JSON.parse(String);
        return module;
    }
    const getModuleSector = () => {
        const String = localStorage.getItem('sector');
        const module = JSON.parse(String);
        return module;
    }

    const getToken = () => {
        const tokenString = localStorage.getItem('token');
        const token = JSON.parse(tokenString);
        return token;
    }

    const getUser = () => {
        const userString = localStorage.getItem('user');
        const user = JSON.parse(userString);
        return user;
    }

    const getRol = () => {
        const rolString = localStorage.getItem('rol');
        const rol = JSON.parse(rolString);
        return rol;
    }

    const getApodoSector = () => {
        const apodoSectorString = localStorage.getItem('apodosector');
        const apodoSector = JSON.parse(apodoSectorString);
        return apodoSector;
    }

    const getPuntoDeVenta = () => {
        const pvString = localStorage.getItem('pv');
        const pv = JSON.parse(pvString);
        return pv;
    }

    const [token, setToken] = useState(getToken);
    const [user, setUser] = useState(getUser);
    const [rol, setRol] = useState(getRol);

    const saveToken = (user, token, rol, modulo, sector, apodosector, pv) => {
        localStorage.setItem('user', JSON.stringify(user))
        localStorage.setItem('token', JSON.stringify(token))
        localStorage.setItem('rol', JSON.stringify(rol))
        localStorage.setItem('modulo', JSON.stringify(modulo))
        localStorage.setItem('sector', JSON.stringify(sector))
        localStorage.setItem('apodosector', JSON.stringify(apodosector))
        localStorage.setItem('pv', pv || null)
        setUser(user)
        setToken(token)
        setRol(rol)
        if (getRol() === "client")
            navigate('/' + modulo)
        else
            navigate('/')
    }

    const getLogout = () => {
        if (getRol() === "visit") {
            if (getToken()) {
                if (getToken() == "Visit|Token") {
                    unsubscribeFromNotifications();
                    localStorage.clear();
                } else {
                    localStorage.setItem('rol', JSON.stringify("client"))
                }
            }

        } else {
            unsubscribeFromNotifications();
            localStorage.clear();
        }
        navigate('/')
    }

    return {
        setToken: saveToken,
        user,
        token,
        rol,
        getToken, getRol, getUser, getLogout, getModule, getModuleSector, getApodoSector, getPuntoDeVenta
    }
}

export default AuthUser
